/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto } from './WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto';
import {
    WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoFromJSON,
    WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoFromJSONTyped,
    WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoToJSON,
} from './WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto';

/**
 * 
 * @export
 * @interface WebApiMemberDtoPreviewMailBodyDto
 */
export interface WebApiMemberDtoPreviewMailBodyDto {
    /**
     * 
     * @type {string}
     * @memberof WebApiMemberDtoPreviewMailBodyDto
     */
    message?: string | null;
    /**
     * 
     * @type {WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto}
     * @memberof WebApiMemberDtoPreviewMailBodyDto
     */
    design?: WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDto;
}

/**
 * Check if a given object implements the WebApiMemberDtoPreviewMailBodyDto interface.
 */
export function instanceOfWebApiMemberDtoPreviewMailBodyDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiMemberDtoPreviewMailBodyDtoFromJSON(json: any): WebApiMemberDtoPreviewMailBodyDto {
    return WebApiMemberDtoPreviewMailBodyDtoFromJSONTyped(json, false);
}

export function WebApiMemberDtoPreviewMailBodyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiMemberDtoPreviewMailBodyDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'message': !exists(json, 'message') ? undefined : json['message'],
        'design': !exists(json, 'design') ? undefined : WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoFromJSON(json['design']),
    };
}

export function WebApiMemberDtoPreviewMailBodyDtoToJSON(value?: WebApiMemberDtoPreviewMailBodyDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'message': value.message,
        'design': WebApiServicesDataTransferObjectsEmailServiceEmailTemplateDesignDtoToJSON(value.design),
    };
}

